import { em } from 'polished'
import styled from 'styled-components'

import { Col } from 'styles/components/layout'

export const Wrapper = styled.div`
  background: ${p => p.theme.colors.grayOp06NonTransp};

  ${p => p.theme.mq.upLg} {
    background: transparent;
  }
`

export const ColStyled = styled(Col)`
  ${p => p.theme.mq.upLg} {
    margin-left: ${100 * (2 / 12)}%;
  }
`

export const FormBlock = styled.div`
  background: ${p => p.theme.colors.grayOp06NonTransp};
  padding-top: ${em(40)};
  padding-bottom: ${em(40)};

  ${p => p.theme.mq.upLg} {
    border-top-left-radius: ${p => p.theme.blocks.blockBorderRadius};
    border-top-right-radius: ${p => p.theme.blocks.blockBorderRadius};
    margin-left: -${p => p.theme.indents.baseIndentMd};
    margin-right: -${p => p.theme.indents.baseIndentMd};
    padding-left: ${p => p.theme.indents.baseIndentMd};
    padding-right: ${p => p.theme.indents.baseIndentMd};
  }
`
